import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'shop',
    serviceName: 'graphql',
    query: gql`
      query shop($ids: [String], $for_admin: Int) {
        shop(ids: $ids, for_admin: $for_admin) {
          data {
            payment_type
            min_free_ship
            min_order_cost
            send_orders_options
          }
        }
      }
    `,
  },
  update: {
    name: 'updateShop',
    serviceName: 'shopadmin',
    query: gql`
      mutation updateShop(
        $ids: [String]!
        $payment_type: String
        $min_free_ship: String
        $min_order_cost: String
        $send_orders_options: String
      ) {
        updateShop(
          ids: $ids
          payment_type: $payment_type
          min_free_ship: $min_free_ship
          min_order_cost: $min_order_cost
          send_orders_options: $send_orders_options
        ) {
          messages
        }
      }
    `,
  },
};

export default schema;
